<!--
     <CheckboxInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → true/false

     Accepted props:
     - value
     - label
-->

<template>
  <v-checkbox
    v-model="checked"
    :label="props.label"
    color="primary"
    hide-details
    :class="['qmkey-checkbox-input',props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input', { required: props.required }]"
    :disabled="!!props.disabled || !!props.readonly"
    @change="update"
  ></v-checkbox>
</template>


<script>
 export default {
   name: 'CheckboxInput',

   props: ['props'],

   data: () => ({
     valid: true,
     checked: false,
   }),

   computed: {
     value() {
       return this.checked;
     },
   },

   mounted() {
     this.checked = !!this.props.value;
   },

   methods: {
     validate() {
       return true;
     },
     
     update(value) {
      this.$emit('update',value)
     },
   },

   watch: {
     props() {
       this.checked = !!this.props.value;
     },
   },
 }
</script>
<style lang="scss">
  @import '@/sass/modalform.scss';
  .qmkey-checkbox-input{
    margin-top: 0px !important;
  }
</style>
